module.exports = __webpack_public_path__ + "b3c6aa6d2173b047fb9cfc5902fcacde.png";